<template>
  <div>
    <div v-if="!loggedIn && settings && homeHtml">
      <div v-html="homeHtml"></div>
    </div>

    <mdb-container v-if="loggedIn && userDetails" class="gp-has-header">
      <top-alerts></top-alerts>

      <div v-if="translationMode">
        <translate-section category="page" sub-category="home"/>
      </div>

      <mdb-card class="mb-4 text-left" v-if="meetings.length>0">
        <mdb-card-header class="pr-1">
          <h5>{{ $t("page.home.myOnlineMeetings") }}
          </h5>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-tbl responsive striped>
            <mdb-tbl-body>
              <tr v-for="m in meetings" :key="m.id">
                <td><h4 class="text-info">{{ m.name }}</h4></td>
                <td>
                  <mdb-btn @click="joinMeeting(m)" color="success" icon="handshake" size="sm" rounded>
                    {{ $t("common.button.join") }}
                  </mdb-btn>
                </td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
          <div v-if="meetingMessage" v-html="meetingMessage"></div>
        </mdb-card-body>
      </mdb-card>

      <mdb-row v-for="(block,i) in userDetails.pageBlocks" v-if="block.location=='FullTop'" :key="i">
        <mdb-col :md="12">
          <mdb-card class="mb-4">
            <mdb-card-header class="pr-1">
              <h5>{{ block.name }}</h5>
            </mdb-card-header>
            <mdb-card-body>
              <div class="text-left" v-html="block.html"/>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="8">
          <mdb-card v-for="(block,i) in userDetails.pageBlocks" v-if="block.location=='Left'" :key="i" class="mb-4">
            <mdb-card-header class="pr-1">
              <h5>{{ block.name }}</h5>
            </mdb-card-header>
            <mdb-card-body>
              <div class="text-left" v-html="block.html"/>
            </mdb-card-body>
          </mdb-card>

          <mdb-card v-if="userDetails.name != 'Guest' && userDetails.groups && userDetails.groups.length == 0
                      && userDetails.visited && userDetails.visited.length == 0" class="animated bounceIn mb-4">
            <mdb-card-header class="secondary-color">
              <h5 id="welcome-message">
                <mdb-icon class="pr-1" icon="handshake"/>
                {{ $t("page.home.welcomeMessage", {name: userDetails.name}) }}
              </h5>
            </mdb-card-header>
            <mdb-card-body>
              <p>
                {{ $t("page.home.thanksForJoining", {site: settings.siteName}) }}
              </p>
              <mdb-btn darkWaves gradient="blue" icon="search" rounded size="sm" @click="$router.push('/explore')">
                {{ $t("common.button.explore") }} {{ capitalize($tc("common.label.group", 2)) }}
              </mdb-btn>
              <mdb-btn darkWaves gradient="blue" icon="plus-circle" rounded size="sm"
                       v-if="userDetails.mayCreateGroup"
                       @click="$router.push('/newGroup')">{{ $t("page.home.createAGroup") }}
              </mdb-btn>
            </mdb-card-body>
          </mdb-card>
          <mdb-card v-if="userDetails.visited && userDetails.visited.length > 0" class="mb-4">
            <mdb-card-header class="text-left" v-if="userDetails.groups.length > 0">
              <mdb-icon class="pr-1" icon="users"/>
              {{ $t("page.home.likeToJoin") }}
            </mdb-card-header>
            <mdb-card-header class="text-left" v-if="userDetails.groups.length == 0">
              <mdb-icon class="pr-1" color="danger" icon="hand-paper"/>
              {{ $t('page.home.visitedNotJoined') }}
            </mdb-card-header>

            <mdb-card-group deck>
              <group-card v-for="group in userDetails.visited" v-bind:key="group.id" :group="group"
                          :addLink="$t('page.home.notInterested')" @click="removeTrack(group)"/>
            </mdb-card-group>

            <mdb-card-footer class="mt-2">
              <a href="/explore">{{ $t('page.home.findOtherGroups') }}.</a>
            </mdb-card-footer>

          </mdb-card>

          <mdb-card v-if="userDetails.upNext"
                    class="text-left mb-4 animated bounceIn">
            <mdb-card-header>
              <mdb-icon class="pr-1" icon="calendar-alt"/>
              <span v-if="userDetails.upNext.happeningNow"><i>{{ $t('page.home.happeningNow') }}</i></span>
              <span v-if="!userDetails.upNext.happeningNow">{{ $t('page.home.upNext') }}</span>
            </mdb-card-header>
            <div class="group-banner"
                 v-bind:style="'background-image: url(\'' + userDetails.upNext.banner + '\'); background-position-y: ' + userDetails.upNext.bannerYPosition">
            </div>

            <mdb-card-body>
              <div class="group-label">{{ userDetails.upNext.group }}</div>
              <router-link :to="{path: 'event/show/' + userDetails.upNext.id}">
                <h4 class="h4">{{ userDetails.upNext.title }}
                  <mdb-badge v-if="userDetails.upNext.counts.going>0" color="info" pill>
                    <mdb-popover :options="{placement: 'bottom'}" trigger="hover">
                      <div slot="body">
                        <mdb-list-group>
                          <mdb-list-group-item>{{ userDetails.upNext.counts.going }} {{
                              $t('common.label.going')
                            }}
                          </mdb-list-group-item>
                          <mdb-list-group-item>{{ userDetails.upNext.counts.waiting }}
                            {{ $t('common.label.waiting') }}
                          </mdb-list-group-item>
                        </mdb-list-group>
                      </div>
                      <span slot="reference">
                        <mdb-icon icon="users"/>
                        {{ userDetails.upNext.counts.going }}
                      </span>
                    </mdb-popover>
                  </mdb-badge>
                  <mdb-badge v-if="userDetails.upNext.counts.memberGoing" color="success" pill>
                    <mdb-icon icon="check"/>
                    {{ $t("common.label.going") | capitalize }}
                  </mdb-badge>
                  <mdb-badge v-if="userDetails.upNext.counts.memberWaiting" color="warning" pill>
                    <mdb-icon icon="clock"/>
                    {{ $t("common.label.waiting") | capitalize }}
                  </mdb-badge>
                </h4>
              </router-link>
              <h5 class="h5">{{ userDetails.upNext.startDate }}</h5>
            </mdb-card-body>
            <mdb-card-footer>
              <mdb-btn icon="calendar-star" rounded size="sm" @click="$router.push('/user/events')">
                {{ $t('page.home.allMyEvents') }}
              </mdb-btn>
              <mdb-btn icon="calendar" rounded size="sm" @click="$router.push('/calendar')">
                {{ $t('page.home.myCalendar') }}
              </mdb-btn>
            </mdb-card-footer>
          </mdb-card>
          <mdb-card v-if="userDetails.visitedEvents.length>0" class="mb-4">
            <mdb-card-header class="text-left">
              <mdb-icon class="pr-1" icon="clock"/>
              {{ $t('page.home.recentlyVisitedEvents') }}
              <div style="float:right">
                <a @click="toggleHideRecent">
                  <mdb-icon v-if="hideRecentEvents" icon="chevron-double-left"/>
                  <mdb-icon v-if="!hideRecentEvents" icon="chevron-double-down"/>
                </a>
              </div>
            </mdb-card-header>
            <mdb-card-body v-if="!hideRecentEvents" class="text-left">
              <div v-for="event in userDetails.visitedEvents" :key="event.id" class="pb-2">
                <div class="group-label">{{ event.group }}</div>
                <div>
                  <router-link :to="'/event/show/'+event.id">{{ event.date }} - {{ event.title }}</router-link>
                </div>
              </div>
            </mdb-card-body>
          </mdb-card>
          <mdb-card v-if="userDetails.groups && userDetails.groups.length==1" class="mb-4">
            <mdb-card-header class="text-left">
              <mdb-icon class="pr-1" icon="users"/>
              {{ $tc('page.home.myGroup', 1) }}
            </mdb-card-header>
            <div class="group-banner"
                 v-bind:style="'background-image: url(\'' + userDetails.groups[0].banner + '\');'">
              <div class="group-overlay-container">
                <router-link :to="{ path: userDetails.groups[0].homeUrl}">
                  <div class="group-overlay-name text-on-accent">{{ userDetails.groups[0].name }}
                    <mdb-badge v-if="userDetails.groups[0].status == 'Pending'" color="warning">
                      {{ capitalize($t('common.label.approvalPending')) }}
                    </mdb-badge>
                  </div>
                </router-link>
              </div>
            </div>

          </mdb-card>

          <mdb-card v-if="userDetails.groups && userDetails.groups.length > 1">
            <mdb-card-header class="text-left mb-4">
              <mdb-icon class="pr-1" icon="users"/>
              {{ $tc('page.home.myGroup', 2) }}
            </mdb-card-header>
            <mdb-card-body>
              <mdb-row>
                <div v-for="(g,i) in userDetails.groups" :key="i" class="col-md-4 align-self-stretch">
                  <router-link :to="{ path: g.homeUrl}">
                    <mdb-card class="face front mb-4">
                      <mdb-card-header>
                        <mdb-badge v-if="g.status == 'Pending'" color="warning">
                          {{ capitalize($t('common.label.approvalPending')) }}
                        </mdb-badge>
                      </mdb-card-header>
                      <mdb-view hover zoom>
                        <mdb-card-image
                          :src="g.avatar"
                          alt="Card image cap"
                        ></mdb-card-image>
                        <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>
                      </mdb-view>
                      <mdb-card-body>
                        <div class="group-name-text">
                          {{ g.name }}
                        </div>
                      </mdb-card-body>
                    </mdb-card>
                  </router-link>
                </div>
              </mdb-row>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
        <mdb-col md="4">

          <mdb-card v-if="crossTenant" class="text-left mb-4">
            <mdb-card-header>
              <mdb-icon class="pr-1" icon="globe"/>
            </mdb-card-header>
            <mdb-card-body class="mb-2">
              <div v-for="t in tenants" :key="t.id">
                You also have
                  <avatar :avatar="t.icon" :size="75" v-if="t.icon"/>
                {{ t.memberships }} {{ t.memberships.length == 1 ? 'membership' : 'memberships' }}
                on <div class="link cursor-pointer" @click="crossTenantConnect(t.id)">{{ t.name }} <mdb-icon icon="external-link"/>.</div>

              </div>
            </mdb-card-body>

          </mdb-card>

          <mdb-card v-for="(block,i) in userDetails.pageBlocks" v-if="block.location=='Right'" :key="i" class="mb-4">
            <mdb-card-header class="pr-1">
              <h5>{{ block.name }}</h5>
            </mdb-card-header>
            <mdb-card-body>
              <div class="text-left" v-html="block.html"/>
            </mdb-card-body>
          </mdb-card>

          <div>
            <activity-feed :show-links="true"/>
          </div>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <mdb-modal v-if="showProfileReview" class="animated"
               info position="top-left" removeBackdrop
               side @close="showProfileReview = false">
      <mdb-modal-header>
        <p class="heading">{{ $t('page.home.profileIncomplete') }}</p>
      </mdb-modal-header>
      <mdb-modal-body>
        <p class="text-left">
          <router-link to="/user/profile">{{ $t('page.home.profileReviewLink') }}</router-link>
        </p>
        <p class="small text-info"><i>{{ $t('page.home.profileIncomplete') }}</i></p>

        <p v-if="!userDetails.hasAvatar" class="text-left">
          {{ $t('page.home.needAvatar') }}
          <router-link to="/user/profile">{{ $t('page.home.profileReviewLink') }}</router-link>
        </p>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardGroup,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbJumbotron,
  mdbListGroup,
  mdbListGroupItem,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavbarNav,
  mdbNavbarToggler,
  mdbNavItem,
  mdbPopover,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbView
} from 'mdbvue';
import activityFeed from './ActivityFeed'
import groupCard from './group/Card'
import avatar from "./common/Avatar";
import api from '../services/groupsPlaceApi'
import gpCookie from "../services/gpCookie";
import explore from "./Explore";
import topAlerts from "./common/TopAlerts";
import EzumeePublicLanding from "./EzumeePublicLanding";
import GroupsPlacePublicLanding from "./GroupsPlacePublicLanding";
import SumatoPublicLanding from "./SumatoPublicLanding";
import translateModal from "./common/TranslateModal";
import translateSection from "./common/TranslateSection";

export default {
  name: 'Home',
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbBadge,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbJumbotron,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbBtn,
    mdbView,
    mdbPopover,
    mdbNavbar,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbInput,
    mdbMask,
    mdbNavbarBrand,
    mdbCardGroup,
    mdbListGroup,
    mdbListGroupItem,
    mdbIcon,
    mdbTbl,
    mdbTblBody,
    activityFeed,
    groupCard,
    explore,
    topAlerts,
    EzumeePublicLanding,
    GroupsPlacePublicLanding,
    SumatoPublicLanding,
    translateModal,
    translateSection,
    avatar
  },
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    },
    currentGroup() {
      return this.$store.state.currentGroup
    },
    executing() {
      return this.$store.state.executing
    },
    settings() {
      return this.$store.state.settings
    },
    apiKey() {
      return this.$store.state.apiKey
    },
    loggedIn() {
      return this.$store.state.loggedIn
    },
    detailsStamp() {
      return this.$store.state.detailsLoadedStamp
    },
    group() {
      return this.$store.state.currentGroup
    },
    language() {
      return this.$store.state.language
    },
    mobileImage() {

    },
    translationMode() {
      return this.$store.state.translationMode
    }
  },
  metaInfo() {
    return {
      link: [
        {
          rel: "canonical",
          href: this.settings.staticSiteUrl
        }
      ]
    }
  },
  watch: {
    language: function (newLang) {
      console.log("Language changed to ", newLang)
      if (!this.loggedIn) {
        this.homeHtml = this.appPages[newLang]
        this.handleAppPage()
      }
    },
    userDetails: function (ud) {
      if (!ud) return
      if (!this.currentGroup && ud.currentGroup) {
        //set the contextual group menu to the last group visited
        let group = api.groupBasics(ud.currentGroup, "member")
      }

      if (ud.newUserChecklist) {
        this.$router.push("/new-user")
        return
      } else {
        if (ud.name != 'Guest' && ud.groups.length == 0 && ud.visited.length == 0) {
          this.$router.push("/explore")
          return
        }
      }

      if (ud.name != 'Guest' && ud.groups.length == 0 && ud.visited.length == 1) {
        this.$router.push("/group/" + ud.visited[0].id)
        return
      }

      this.loadMeetings()
      this.loadCrossTenant()


    }
  },
  async mounted() {
    if (this.settings.siteName) document.title = this.settings.siteName
    if (this.settings.favIcon) document.querySelector("link[rel*='icon']").href = this.settings.favIcon

    let hre = gpCookie.getCookie("hide-recent-events")
    if (hre && hre == 'true') {
      this.hideRecentEvents = true
    }
    if (this.loggedIn && this.detailsStamp) {
      //if we didn't just log on and have done other stuff to return home, things could have changed.
      let curr = new Date()
      let diff = (curr - this.detailsStamp) / 1000
      if (diff > 60) api.reloadUser()
    }
    if (this.loggedIn) {
      this.loadMeetings()
      this.loadCrossTenant()
    } else {
      this.loadAppHome()
    }
    this.$nextTick().then(() => {
      window.scrollTo(0, 0)
    })

    setTimeout( () => {
      this.registerQC()
    }, 1000)



  },
  data() {
    return {
      hideRecentEvents: false,
      showProfileReview: false,
      meetings: [],
      appPages: null,
      meetingMessage: "",
      homeHtml: null,
      crossTenant: false,
      tenants: []
    }
  },
  methods: {
    registerQC() {
      let emailInput = document.getElementById("quick-connect-email-address")
      if (emailInput) {
        emailInput.focus()
      }

      let quickConnectButton = document.getElementById('quick-connect-submit')
      if (quickConnectButton) {
        quickConnectButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleQuickConnectSubmit();
        });
      }
      console.log("Registerd QC")
    },
    handleQuickConnectSubmit() {
      let emailInput = document.getElementById("quick-connect-email-address")
      if (!emailInput) return
      if (!emailInput.value) {
        this.$notify.error({message: "Email Address Required", timeOut: 5000})
        return
      }
      if (emailInput.validity.typeMismatch) {
        this.$notify.error({message: "Invalid Email Address", timeOut: 5000})
        return
      }
      this.$router.push("/quick-connect?email=" + encodeURIComponent(emailInput.value ))
    },
    loadCrossTenant: function () {
      if (!this.loggedIn) return
      api.get("/user/loadCrossTenant").then(
        (results) => {
          this.tenants = results.data
          if (this.tenants.length > 0) this.crossTenant = true
          else this.crossTenant = false
        })
    },
    joinMeeting: function (m) {
      this.$store.dispatch("setExecuting", true);
      api.get("/jitsi/instantJwt/" + m.id).then(
        (results) => {
          let url = results.data.url
          url += "?jwt=" + results.data.jwtToken
          window.open(url, "_blank")
          this.meetingMessage = `<div class="text-info">Online event should have opened in a new window/tab. If it didn't,
          your browser may have treated it as a pop-up and blocked it. If that's the case, try <a href="${url}">this alternate link</a>. It is good for 1 hour. You can
          re-generate it by hitting the join button again.
          </div>`
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    loadMeetings() {
      if (!this.loggedIn) return
      this.$store.dispatch("setExecuting", true);
      this.meetings = []
      api.get("/jitsi/listMeetings").then(
        (results) => {
          for (let m of results.data.created) {
            this.meetings.push(m)
          }
          for (let m of results.data.invited) {
            this.meetings.push(m)
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    loadAppHome() {
      this.$store.dispatch("setExecuting", true);
      api.get("/public/appHome").then(
        (results) => {
          this.appPages = results.data
          if (this.language) this.homeHtml = this.appPages[this.language]
          else this.homeHtml = this.appPages["en"]
          this.handleAppPage()
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    handleAppPage() {
      /*allow for special messages/sections for iphone and android users not using standalone. App HTML can have
        sections hidden and we can unhide below as necessary. */
      this.$nextTick().then(() => {
        if (! api.isStandalone() && /iPhone/.test(navigator.userAgent)) {
          const elements = document.getElementsByClassName("iphone-web-only")
          for (const element of elements) {
            element.style.display = "block"
          }
        }
        if (! api.isStandalone() && /Android/.test(navigator.userAgent)) {
          const elements = document.getElementsByClassName("android-web-only")
          for (const element of elements) {
            element.style.display = "block"
          }
        }
      })
    },
    toggleHideRecent() {
      this.hideRecentEvents = !this.hideRecentEvents
      gpCookie.setCookie('hide-recent-events', this.hideRecentEvents)

    },
    removeTrack(group) {
      this.$store.dispatch("setExecuting", true)
      api.delete("/user/groupInterest/" + group.id).then(
        (details) => {
          let loc = this.userDetails.visited.indexOf(group)
          this.userDetails.visited.splice(loc, 1)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 10000})
        }
      ).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    crossTenantConnect(tenantId) {
      api.get(`/user/crossTenantLink/${tenantId}`).then(
        (results) => {
          window.open(results.data.url, "_blank")
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h4 {
  margin: 0;
}

.group-banner {
  display: block;
  width: 100%;
  background-size: cover;
  padding-top: 25%;
}

.group-label {
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 600;
}

.navbar .md-form {
  margin: 0;
}

@media (max-width: 990px) {
  .gp-intro {
    margin-top: 300px;
  }
}

@media (max-height: 599px) {
  .gp-intro {
    margin-top: 375px;
  }
}

h6 {
  line-height: 1.7;
}

.logo-top {
  height: 50px;
  margin: auto;
}

.group-name-text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.group-overlay-container {
  background-color: #ffffff;
  opacity: 0.8;
  padding-left: 10px;
  padding-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: absolute;
  bottom: 30px;
}

.group-overlay-name {
  font-size: 1.5em;
  opacity: 1;
}

</style>
